/* eslint-disable  import/no-cycle -- need */
import { performOperations } from '../Operations/Operations';
import {
  cardVerify, creditStatus, finsTransactions, lookupData, getMemberEmail,
  fetchItrackerStatus, createClicCase, ibanVerification, stageOneSubmit,
  resumeJourney, getCityStateByPincode,
  fetchCardDetails, c360Verification, aceVerification, triggerAPI,
} from './utilService';

/* eslint-disable no-restricted-syntax -- need */
export const apiHandler = async (props) => {
  const apiMapping = {
    finsTransactions,
    lookupData,
    creditStatus,
    getMemberEmail,
    cardVerify,
    cardVerifySubmit: cardVerify,
    fetchItrackerStatus,
    createClicCase,
    stageOneSubmit,
    resumeJourney,
    getCityStateByPincode,
    fetchCardDetails,
    ibanVerification,
    c360Verification,
    aceVerification,
    triggerAPI,
  };

  const {
    apiName, callType = 'standAlone',
  } = props;

  // global apiObject --> maintains state of api call --> inprogress, success, failed, cache?
  /**
   * apiStates = {
   * "finsTransactions": {
   *  status: "inProgress",
   * cache: {
   * "accountToken1": data1,
   *  "accountToken2": data2,
   * }
   * currentData: {}
   * }
   * }
   */
  // delete all these api states before form submit.
  // cardVerify cardVerifySubmit
  if (callType === 'standAlone') {
    await apiMapping[apiName]({ ...props, callType });
  } else if (callType === 'parallel') {
    // create a promise array for parallel api callss
    const { setFormSubmissionPayload } = props.functionObject;
    const { formSubmissionPayload } = props.dataObject;
    const { apisToCall, onSuccess, onFail } = props;
    const promiseArray = [];
    for (const api of apisToCall) {
      // some calls can be conditional mandatory, otherwise we treat them mandatory by default
      // conditional mandotry calls will be added to the promise array only if the condition is met
      promiseArray.push(apiMapping[api.apiName]({ ...props, callType }));
    }
    const results = await Promise.all(promiseArray);
    let allCallsSucessful = true;
    const resultsData = {};
    for (const [i, res] of results.entries()) {
      if (res.statusIndicator === 'T') {
        resultsData[apisToCall[i].apiName] = res.data;
        resultsData[`${apisToCall[i].apiName}Status`] = 'Success';
      } else if (res.statusIndicator === 'F' && apisToCall[i].isCallMandatory) {
        resultsData[`${apisToCall[i].apiName}Status`] = 'Failed';
        allCallsSucessful = false;
      }
    }

    if (allCallsSucessful) {
      // default --> add all the results to formSubmissionPayload --> no navigation
      if (onSuccess?.operations) {
        performOperations({
          ...props,
          operations: onSuccess.operations,
          dataObject: {
            ...props.dataObject,
            formSubmissionPayload: {
              ...formSubmissionPayload,
              ...resultsData,
            },
          },
        });
      } else {
        setFormSubmissionPayload((prev) => ({
          ...prev,
          ...resultsData,
          elemId: null,
        }));
      }
    } else {
      let navigate = 'error';
      if (onFail?.apiFailureNavigation) {
        Object.keys(onFail.apiFailureNavigation).forEach((api) => {
          if (resultsData[`${api}Status`] === 'Failed') {
            navigate = onFail.apiFailureNavigation[api];
          }
        });
      }
      setFormSubmissionPayload((prevPayload) => ({
        ...prevPayload,
        ...resultsData,
        elemId: navigate,
      }));
    }
  }
};
/* eslint-enable  import/no-cycle -- need */
/* eslint-enable no-restricted-syntax -- need */
